var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"app"}},[_c('MaintenanceBanner',{attrs:{"src":_vm.MAINTENANCE_BANNER_SRC}}),_c('ChromeWarning'),_c('router-view'),_c('Version')],1)}
var staticRenderFns = []

export { render, staticRenderFns }